import * as React from 'react'

/**
 * Os dois pedaços de estado que atravessam a página inteira e não têm relação de
 * pai e filho. No Nuxt eram duas linhas de `useState()` global:
 *
 *   • `roi-result`        — o ganho mensal simulado na calculadora, que a barra
 *                           fixa repete lá embaixo;
 *   • `lp-sticky-visible` — se a barra fixa está na tela, porque o botão do
 *                           WhatsApp precisa subir para não ficar embaixo dela.
 *
 * Context em vez de prop: a calculadora está no meio da página e a barra é irmã
 * dela, no fim — não há caminho de prop entre as duas.
 *
 * `roiTotal` (2026-08-13) é o segundo número, além do mensal: o cliente não
 * tem recorrente, então `roiMensal` fica sempre 0/null pra ele e a barra fixa
 * nunca ecoava a simulação dele. `roiTotal` carrega o total (bônus/valor +
 * recorrente, já convertido em créditos se for o caso) pras duas trilhas — a
 * barra escolhe qual mostrar conforme quem está olhando.
 */
const LpStateContext = React.createContext(null)

export function LpStateProvider({ children }) {
  /** null = ninguém simulou ainda, e a barra mostra a chamada padrão. */
  const [roiMensal, setRoiMensal] = React.useState(null)
  const [roiTotal, setRoiTotal] = React.useState(null)
  const [stickyVisible, setStickyVisible] = React.useState(false)

  const valor = React.useMemo(
    () => ({ roiMensal, setRoiMensal, roiTotal, setRoiTotal, stickyVisible, setStickyVisible }),
    [roiMensal, roiTotal, stickyVisible]
  )

  return <LpStateContext.Provider value={valor}>{children}</LpStateContext.Provider>
}

function useLpState() {
  const ctx = React.useContext(LpStateContext)
  if (!ctx) throw new Error('Componente da LP usado fora de <LpStateProvider>')
  return ctx
}

export function useRoiResult() {
  const { roiMensal, setRoiMensal, roiTotal, setRoiTotal } = useLpState()
  return { mensal: roiMensal, setMensal: setRoiMensal, total: roiTotal, setTotal: setRoiTotal }
}

export function useStickyBar() {
  const { stickyVisible, setStickyVisible } = useLpState()
  return { visible: stickyVisible, setVisible: setStickyVisible }
}
